export const MERC_FAVORITE_LOCAL_STORAGE_KEY = 'merc-favorite';
export const MERC_USER_FACET_LOCAL_STORAGE_KEY = 'merc-user-facet';
